import type { CauseAgg } from './utils';
import { fmtInt } from './utils';
import s from './BroadcastDetailsModal.module.css';

interface Props {
  causes: CauseAgg[];
  active: string | null;
  onChange: (key: string | null) => void;
  label?: string;
}

export function CauseChips({ causes, active, onChange, label = 'Causas' }: Props) {
  if (!causes.length) return null;
  return (
    <div className={s.chipRow}>
      <span className={s.overline}>{label}</span>
      {causes.map((c) => {
        const on = active === c.key;
        return (
          <button
            key={c.key}
            type="button"
            title={c.description}
            className={s.chip}
            style={{ borderColor: on ? c.color : undefined, background: on ? '#fff' : undefined, opacity: !active || on ? 1 : 0.5 }}
            onClick={() => onChange(on ? null : c.key)}
          >
            <span className={s.sq} style={{ background: c.color }} />
            {c.label}
            <b>{c.leads ? fmtInt(c.leads) : `${c.pages} pág.`}</b>
          </button>
        );
      })}
      {active && (
        <button type="button" className={s.linkBtn} onClick={() => onChange(null)}>limpar</button>
      )}
    </div>
  );
}
